import { JSONApiInterceptorResponse } from '../../../../wrapped-cube-client/interceptors/JSONApi-interceptors';
import Client from '../../../../wrapped-cube-client';
import { actionCreators as requestActionCreators } from '../../../ducks/request-status';
import { actionCreators } from '../../../ducks/uploads';
import { actionCreators as uiActionCreators } from '../../../ducks/ui';
import { addFileStub } from '../v2/addFileStub';
import { normalizeFiles } from './normalizeFiles';

let total = 0;
let created = 0;

export const handleTree = (
  parentFolderId,
  tree,
  metadata,
  dispatch,
  getState,
  workspaceId
) => {
  dispatch(uiActionCreators.setUploadQueueBusy(true));

  total += tree.allFolders.length;

  const structure = tree.allFolders
    // make sure we create the folder promises starting at the lowest depth
    // so nested folders alway have a parent folder promise to wait on
    .sort((a, b) => a.depth - b.depth)
    // create a look-up for folder creation promises, using temp uuids as keys
    .reduce(
      (acc, val) => {
        // add promise for folder creation to look-up
        acc[val.tempId] = new Promise((resolve, reject) => {
          // we need to wait for parent folder to be created, before we can
          // create nested folders
          acc[val.parent.tempId]
            .then((parentId) => {
              // acc[val.parent.tempId] = Client.post(
              Client.post(
                'folder',
                { display_name: val.name, type: 'folder' },
                { type: 'folder', id: parentId, field: 'folders' }
              ).then((res: JSONApiInterceptorResponse) => {
                const id = res.data.primary[0].id;
                // resolve the id, so nested folder can use it as parentId
                resolve(id);
              });
              // .then((res) => parentId);
            })
            .catch((e) => {
              console.info('DEBUG folder creation failed', e);

              reject(e);
            });
        });
        return acc;
      },
      { [tree.tempId]: Promise.resolve(parentFolderId) }
    );

  // for all folders (including root) create regular file upload actions

  [...tree.allFolders, tree].forEach((f) => {
    // hook into the folder creation promises (that have already finished)
    // to get the folder Ids
    structure[f.tempId]
      .then((fId) => {
        if (getState().session.workspace !== workspaceId) {
          throw new Error('Worskpace mismatched, canceling uploads');
        }

        console.info('DEBUG UPLOADS: start upload here');
        created += 1;
        dispatch(
          uiActionCreators.setUploadQueueFolderPercentage(
            (created / total) * 100
          )
        );

        if (f.files.length) {
          dispatch(actionCreators.uploadFilesToFolder(f.files, fId, metadata));
        }
      })
      .catch((e) => {
        console.error('DEBUG upload failed', e);
        const now = Date.now();
        normalizeFiles(f.files, metadata).forEach((f, idx) => {
          // this is just a placeholder,
          // will get overriden once the actual tus upload is created
          addFileStub(
            f,
            { type: 'folder', id: parentFolderId },
            dispatch,
            getState,
            now + idx,
            workspaceId,
            'assets',
            { status: 'failed', failed: true }
          );
        });
      });
  });

  Promise.allSettled(Object.keys(structure).map((k) => structure[k]))
    // .then((res) => {

    // })
    .then((done) => {
      console.info('DEBUG UPLOADS: folder creation done');

      // trigger reload of the root folder
      dispatch(
        requestActionCreators.invalidateRelationship({
          type: 'folder',
          id: parentFolderId,
          relationship: 'folders'
        })
      );
      dispatch(
        requestActionCreators.invalidateRelationship({
          type: 'folder',
          id: parentFolderId,
          relationship: 'assets'
        })
      );

      total -= tree.allFolders.length;
      created -= tree.allFolders.length;
      dispatch(uiActionCreators.setUploadQueueBusy(false));
      dispatch(
        uiActionCreators.setUploadQueueFolderPercentage((created / total) * 100)
      );
    });
};
